import { handleActions } from 'redux-actions';

import { updateGuestServicesRequests } from './actions';

export default handleActions(
  {
    [updateGuestServicesRequests]: (state, { payload: { data } }) => ({
      ...state,
      ...data,
    }),
  },
  {},
);
